import * as _ from 'lodash';
import { FormEvent } from 'react';
import { IKidneyStoneRejectionItem, IListItem } from '@nkr/models/index';
import { Col, ControlLabel, Form, FormControl, Label, Panel, Row } from 'react-bootstrap'

interface IProps {
    kidneyStoneRejectionList: IKidneyStoneRejectionItem[],
    statusList: IListItem[],
    onChange: (index: number, value: number) => void
}

const KidneyStones = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading>Rule out on Kidney Stones &nbsp;<Label bsStyle='warning'>KIDNEY ONLY</Label></Panel.Heading>
            <Panel.Body>
                <Form horizontal>
                    <Row>
                        <Col xs={4} sm={1}>
                            Stones
                        </Col>
                        <Col xs={8} sm={5}>
                            Remission Required
                        </Col>
                    </Row>
                    {props.kidneyStoneRejectionList.map(item =>
                        <Row className='row-margined'>
                            <ControlLabel className='col-xs-4 col-sm-1' style={{ textAlign: 'left' }}>
                                {item.index} stone
                            </ControlLabel>
                            <Col xs={8} sm={5}>
                                <FormControl
                                    componentClass='select'
                                    className='form-control'
                                    id={`kidney-remission-${item.index}`}
                                    value={item.value}
                                    onChange={(e: FormEvent<FormControl & HTMLSelectElement>) => props.onChange(item.index, parseInt(e.currentTarget.value))}
                                >
                                    <option value={-1}>Never Rule Out</option>
                                    <option value={-2}>Always Rule Out</option>
                                    {props.statusList.map((item, index) =>
                                        <option key={'remission-value-' + index} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </Row>
                    )}
                </Form>
            </Panel.Body>
        </Panel>
    );
}

export default KidneyStones;